import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { assessmentActions, questionsActions } from "../../../_actions";
import Dashboard from "../Dashboard/Dashboard";
import StatsCard from "../../AdminPanel/Component/UI/StatsCard";
import { LuUsers, LuUserCheck, LuDownload } from "react-icons/lu";
import { SlReload } from "react-icons/sl";
import { MdOutlineArrowBack } from "react-icons/md";
// import { MdArrowForwardIos } from "react-icons/md";
import Heading from "../../AdminPanel/Component/UI/Heading";
import SelectOption from "../../AdminPanel/Component/UI/SelectOption";
// import ViewButton from "../../AdminPanel/Component/UI/ViewButton";
// import TriangleChart from "./Charts/TriangleChart";
import HeatMap from "./Component/HeatMap";
import RankMap from "./Component/RankMap";
import BubbleMap from "./Component/BubbleMap";
import moment from 'moment';


class SummaryDashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      surveyLanguageCode: 'en',
      surveyLanguageName: 'English',
      surveyLanguageRTL: false,
      crrTeamId: localStorage.getItem("crrTeamId") || ""
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    const { crrTeamId } = this.state;
    const temp2 = {
      keyWord: "",
      pageNo: 1,
      size: 100000
    }
    this.props.dispatch(assessmentActions.getCompletedTeamList(temp2, "report2", crrTeamId));
  }

  handleTeamChange = (value) => {
    localStorage.setItem("crrTeamId", value);
    this.setState({ crrTeamId: value }, () => {
      const paginationData = {
        "teamId": value,
        "isAll": true
      }
      const pagination2Data = {
        "teamId": value,
        "isAll": false
      }
      this.props.dispatch(assessmentActions.getAssessmentReportByTeamId(paginationData));
      this.props.dispatch(assessmentActions.getAssessmentReportByTeamIdV2(pagination2Data));
    });
  }

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  render() {
    let { crrTeamId } = this.state;
    const { assessment, questions } = this.props;
    const { getAssessmentReportByTeamIdData,
      getAssessmentReportByTeamIdV2Data,
      userAssessmentUserProfileData, getCompletedTeamListData, loading } = assessment;

    let AssessmentList = getAssessmentReportByTeamIdData;
    let newList = [];
    if (AssessmentList && AssessmentList.length > 0) {
      AssessmentList.forEach((element, index) => {
        let rank = index + 1;
        let getIndex = newList.findIndex(prev => prev.bucket === element.bucket)
        if (getIndex === -1) {
          let temp = {
            "showCount": 0,
            "bucket": element.bucket,
            "colorCode": element.colorCode,
            "dimensions": [{
              "rank": rank,
              "name": element.dimension,
              "count": element.count,
              "finalSum": element.finalSum,
              "colorCode": element.colorCode,
            }],
          }
          newList.push(temp)
        } else {
          newList[getIndex]["showCount"] += 1
          newList[getIndex]["dimensions"].push({
            "rank": rank,
            "name": element.dimension,
            "count": element.count,
            "finalSum": element.finalSum,
            "colorCode": element.colorCode,
          })
        }

      });
    }


    let freqList = [];
    let AssessmentFreqList = getAssessmentReportByTeamIdV2Data;
    if (AssessmentFreqList && AssessmentFreqList.length > 0) {
      AssessmentFreqList.sort((a, b) => a.count - b.count).forEach((element, index) => {
        freqList.push({
          "dimension": element.dimension,
          "count": element.count,
          "size": index + 1,
          "colorCode": element.colorCode,
        })
      })
    }

    if (freqList && freqList.length > 0) {
      freqList.sort((b, a) => a.count - b.count)
    }

    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod()
    };
    const teamNameListData = getCompletedTeamListData && getCompletedTeamListData.length > 0 ? getCompletedTeamListData.map((ele) => ({ value: ele.id, label: ele.name })) : [];


    return (
      <Dashboard userDetails={userDetails} logout={this.logout} loading={loading}>
        <div className="space-y-8 p-8">

          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-3">
              <div className="bg-white hover:text-[#1976D2] textblack border border-[#D1D5DB] p-1.5 rounded-full cursor-pointer" onClick={() => this.props.history.goBack()}>
                <MdOutlineArrowBack size={26} className="inline-block" />
              </div>
              <Heading className="text-xl" title="Assessment Overview" />
            </div>
            <div className="w-64">
              <SelectOption
                name="teamId"
                value={crrTeamId}
                onChange={(e) => this.handleTeamChange(e.target.value)}
                placeholder="Select Team"
                options={teamNameListData}
              />
            </div>
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <StatsCard icon={LuUsers} label="Users Left" value="2" />
            <StatsCard icon={LuUserCheck} label="Users Completed" value="27" />
            <StatsCard icon={SlReload} label="Users Pending" value="27" />
          </div> */}

          {newList && newList.length > 0 ?
            <>
              <HeatMap list={newList} />
              <RankMap list={newList} />
              <BubbleMap list={freqList} />

            </>
            :
            <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
              <div className="bg-white border border-dashed border-[#D1D5DB] rounded-xl p-6 flex flex-col items-center justify-center text-center min-h-[260px]">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-7 w-7 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 17v-2a4 4 0 014-4h2M9 5h6m2 0a2 2 0 012 2v10a2 2 0 01-2 2H7a2 2 0 01-2-2V7a2 2 0 012-2h10z"
                    />
                  </svg>
                </div>

                <p className="text-base font-semibold textblack mb-1">
                  Data not available
                </p>
                <p className="text-sm textlight max-w-xs">
                  No assessment data has been recorded yet. Once assessments are completed,
                  your talent snapshot will appear here.
                </p>
              </div>
            </div>

          }
        </div>

      </Dashboard >
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment
  };
}
export default connect(mapStateToProps)(SummaryDashboard);
